define(['idcta-v2/mvt', 'idcta-v2/id-config', 'idcta-v2/es6-promise'], function(
    mvt,
    config,
    es6Promise
) {
    var exports = {};

    var SIGN_IN_PROMPT_COOKIE_NAME = 'ckns_usip';
    var SIGN_IN_PROMPT_COOKIE_EXPIRY = 14 * 24 * 60 * 60 * 1000;
    var ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;
    var HALF_HOUR_IN_MS = 0.5 * 60 * 60 * 1000;

    function getCookie(name) {
        var value = '; ' + document.cookie;
        var parts = value.split('; ' + name + '=');
        if (parts.length == 2)
            return parts
                .pop()
                .split(';')
                .shift();
    }

    function suppressBbcSurveyModal() {
        var surveyModal = document.getElementById('edr_survey');
        if (surveyModal) {
            surveyModal.style.display = 'none';
        }
    }

    function loadCss(url) {
        var link = document.createElement('link');
        link.type = 'text/css';
        link.rel = 'stylesheet';
        link.href = url;
        document.head.appendChild(link);
    }

    function loadModal(html) {
        var modal = document.createElement('div');
        modal.className = 'usi-overlay';
        modal.id = 'usiOverlay';
        modal.innerHTML = html;
        document.body.appendChild(modal);
    }

    function onTabPress(element, shiftKey, callback) {
        var TAB_KEY_CODE = 9;

        element.addEventListener('keydown', function(event) {
            if (event.target === element && event.keyCode === TAB_KEY_CODE) {
                if (
                    typeof shiftKey === 'undefined' ||
                    event.shiftKey === shiftKey
                ) {
                    event.preventDefault();
                    return callback(event);
                }
            }
        });
    }

    function preventScrollForOldBrowsers(x, y) {
        window.scrollTo(x, y);
    }

    function setFocus(element) {
        var currentXPosition = window.scrollX;
        var currentYPosition = window.scrollY;
        element.focus({
            preventScroll: true,
        });
        preventScrollForOldBrowsers(currentXPosition, currentYPosition);
    }

    function trapFocus(firstElement, lastElement) {
        onTabPress(firstElement, true, function() {
            lastElement.focus();
        });
        onTabPress(lastElement, false, function() {
            firstElement.focus();
        });
    }

    function showModal(response) {
        suppressBbcSurveyModal();
        loadCss(response.css);
        loadModal(response.html);

        var signInButton = document.getElementById('usiModalSignIn');
        var registerButton = document.getElementById('usiModalRegister');

        trapFocus(signInButton, registerButton);

        signInButton.addEventListener('click', function() {
            mvt.sendEvent('prompt_sign_in_click');
        });
        registerButton.addEventListener('click', function() {
            mvt.sendEvent('prompt_register_click');
        });

        window.usiOverlay.style.display = 'block';
        window.usiOverlay.style.zIndex = 1050;
        setFocus(signInButton);
    }

    function sendViewPromptMvtMetrics(destination) {
        mvt.sendAttributes({
            seen_prompt: true,
            product: destination,
        });
        mvt.sendEvent('prompt_viewed');
    }

    function initialiseModal(destination) {
        if (!window.fetch) {
            return;
        }

        return config.getConfigAsync().then(function(config) {
            var ptrt = config.ptrt;

            var modalEndpoint =
                window.idctaBaseUrl +
                '/idcta/modal?ptrt=' +
                ptrt +
                '&context=' +
                destination;

            return fetch(modalEndpoint)
                .then(function(response) {
                    return response.json();
                })
                .then(function(response) {
                    showModal(response);

                    document.dispatchEvent(
                        new CustomEvent('bbc-user-event', {
                            detail: {
                                container: 'id-cta',
                                label: 'id-cta-prompt-usi',
                                metadata: {
                                    'id-cta-type': 'usi-prompt',
                                },
                                source: 'responsive_web',
                            },
                        })
                    );
                });
        });
    }

    function updateCookie(counter) {
        var currentTime = Date.now();
        var expires = new Date(currentTime + SIGN_IN_PROMPT_COOKIE_EXPIRY);
        var maxAge = Math.round(SIGN_IN_PROMPT_COOKIE_EXPIRY / 1000);
        var cookieContent = encodeURIComponent(
            'counter-' + counter + '-lastView-' + currentTime
        );

        document.cookie =
            SIGN_IN_PROMPT_COOKIE_NAME +
            '=' +
            cookieContent +
            '; path=/; expires=' +
            expires +
            '; max-age=' +
            maxAge;

        document.dispatchEvent(new CustomEvent('usiCookieChanged'));
    }

    function getCookieValues() {
        var usipCookie = getCookie(SIGN_IN_PROMPT_COOKIE_NAME);
        var cookieValues = usipCookie.split('-');

        return {
            counter: parseInt(cookieValues[1]),
            lastView: parseInt(cookieValues[3]),
        };
    }

    function hasViewedRecently(lastView, timePeriod) {
        var timeCheck = Date.now() - timePeriod;
        return timeCheck < lastView;
    }

    function usiDecisionMaker(contentType, destination, variantId) {
        var usipCookie = getCookie(SIGN_IN_PROMPT_COOKIE_NAME);

        if (usipCookie) {
            var usiProps = getCookieValues();
            if (contentType === 'index') {
                switch (usiProps.counter) {
                    case 0:
                        if (
                            !hasViewedRecently(usiProps.lastView, ONE_DAY_IN_MS)
                        ) {
                            updateCookie(1);
                        }
                        break;
                    case 1:
                        updateCookie(1);
                        break;
                    default:
                        if (
                            hasViewedRecently(
                                usiProps.lastView,
                                HALF_HOUR_IN_MS
                            )
                        ) {
                            updateCookie(usiProps.counter);
                        } else {
                            updateCookie(1);
                        }
                }
            }

            if (contentType === 'article') {
                switch (usiProps.counter) {
                    case 0:
                        break;
                    case 1:
                    case 2:
                        if (
                            hasViewedRecently(
                                usiProps.lastView,
                                HALF_HOUR_IN_MS
                            )
                        ) {
                            usiProps.counter++;
                            updateCookie(usiProps.counter);
                        }
                        break;
                    default:
                        if (
                            hasViewedRecently(
                                usiProps.lastView,
                                HALF_HOUR_IN_MS
                            )
                        ) {
                            updateCookie(0);
                            sendViewPromptMvtMetrics(destination);
                            var isControlVariant = variantId === 'A';
                            if (!isControlVariant) {
                                return initialiseModal(destination);
                            }
                        }
                }
            }
        } else {
            if (contentType === 'index') {
                mvt.sendAttributes({ seen_prompt: false });
                updateCookie(1);
            }
        }
    }

    function initialise(destination, contentType, variantId) {
        if (!variantId) {
            return;
        }

        return es6Promise.resolve().then(function() {
            return usiDecisionMaker(contentType, destination, variantId);
        });
    }

    function hasInitialised() {
        return Boolean(getCookie(SIGN_IN_PROMPT_COOKIE_NAME));
    }

    exports.initialise = initialise;
    exports.hasInitialised = hasInitialised;

    return exports;
});
